import i18n from '@/libs/i18n'

export enum Errors {
    InternalServerError = 1,
    InvalidData         = 2,
    NotFound            = 3,
    Unauthorized        = 4,
    FailedToInsert      = 5,
    IncorrectStatus     = 6,
    NotConfigured       = 7,
}

export const parseError = (errorObject: unknown, fallback = ''): string => {
    const t = i18n.global.t
    const code = (errorObject as { error?: { code?: number } })?.error?.code
    if (!code) return fallback || t('errors.generic_error')
    switch (code) {
        case Errors.InvalidData:     return t('errors.invalid_data')
        case Errors.NotFound:        return t('errors.not_found')
        case Errors.Unauthorized:    return t('errors.unauthorized')
        case Errors.IncorrectStatus: return t('errors.incorrect_status')
        default:                     return fallback || t('errors.generic_error')
    }
}
